<app-data-table title="School Districts"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                [reloadEmitter]="reloadTable$"
                [enableGlobalSearch]="true"
                [globalFilterFields]="['district_name', 'mapped_district.district']"
                globalSearchPlaceholder="Search by code, district"
                defaultSortField="district_name"
                [exportable]="authService.hasPermission('districts.district_mappings.export')">
</app-data-table>
